import { useRequest } from 'features/request/useRequest';
import { SortEnumType } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { globalConstructionTypes } from '../catalogVariablesQueries';

const constructionTypesVariables = {
    take: 1000,
    order: [{ name: SortEnumType.Asc }],
};

export const useGlobalConstructionTypes = () => {
    const dispatch = useDispatch();

    const [constructionTypes, constructionTypesStatus, , constructionTypesRequest] = useRequest({
        requestId: 'globalConstructionTypes',
        query: globalConstructionTypes,
        variables: constructionTypesVariables,
    });

    const getConstructionTypes = useCallback(() => {
        dispatch(constructionTypesRequest(constructionTypesVariables));
    }, [constructionTypesRequest, dispatch]);

    return {
        constructionTypes: constructionTypes?.globalConstructionTypes?.items,
        fetchingStatus: constructionTypesStatus,
        getConstructionTypes,
    };
};
